RivalIQ.apps.Admin.module('collections', function (collections, Admin, Backbone, Marionette, $, _) {

    'use strict';

    collections.Users = RivalIQ.collections.AtomicCollection.extend({
        model: Admin.models.User,
        url: '/admin/api/users'
    });
});
